import { DetailsSection } from "features/Integration/modules/DetailsSection/DetailsSection";
import { Checklist } from "features/Integration/modules/DetailsSection/modules/Checklist/Checklist";
import React from "react";
import {
  ES_BENEFITS,
  ES_UNLOCKING_KEY_DETAILS,
} from "../../constants/EmailSenderUnlockModal.constants";
import { KeyDetails } from "features/Integration/modules/DetailsSection/modules/KeyDetails/KeyDetails";

export const CustomSenderSection = () => {
  return (
    <DetailsSection
      title={
        <>
          <>
            Benefits of adding your{" "}
            <span className="tw-text-[#493ab1]">custom Email sender ID</span>
          </>
        </>
      }
    >
      <Checklist list={ES_BENEFITS} />

      <KeyDetails keyDetails={ES_UNLOCKING_KEY_DETAILS} className="tw-mt-6" />
    </DetailsSection>
  );
};
